import { FormField } from '@direct-frontend/components';
import { useField, useFormContext, useFormInstance } from '@adv-frontend/form-kit';
import { useLoadingOrder } from '@/entities/order';
import { OrderDeliveryMethods } from '@/shared/api/order';
import { ORDER_FORM_ID } from '../../constants';
import { useChunkIntervals, useIsInvalidOzonUser, useOzonDeliveryInterval, useOzonTriggerProps } from '../../lib';
import { orderForm } from '../../model/forms/orderForm';
import { DeliveryIntervalInput } from '../DeliveryIntervalInput';

interface ChunkIntervalInputProps {
    chunkId: number;
    openRegistrationOzon: VoidFunction;
}

export const ChunkIntervalInput = (props: ChunkIntervalInputProps) => {
    const { chunkId, openRegistrationOzon } = props;
    const { isOrderSideUpdating, isOrderUpdating } = useLoadingOrder();

    const { fields } = useFormInstance({ form: orderForm, id: ORDER_FORM_ID });
    const context = useFormContext({ form: orderForm, id: ORDER_FORM_ID });
    const fieldDeliveryMethod = useField(fields.deliveryMethod);
    const fieldAddressCourier = useField(fields.addressCourier);
    const fieldAddressPickup = useField(fields.addressPickup);
    const isCourierDeliveryMethod = fieldDeliveryMethod.value === OrderDeliveryMethods.COURIER;
    const isPickupPointDeliveryMethod = fieldDeliveryMethod.value === OrderDeliveryMethods.PICKUP_POINT;
    const isCourierAddressFilled = Boolean(isCourierDeliveryMethod && fieldAddressCourier.value.address);
    const isPickupPointAddressFilled = Boolean(isPickupPointDeliveryMethod && fieldAddressPickup.value.pickupPointId);
    const isDeliveryAddressFilled = isCourierAddressFilled || isPickupPointAddressFilled;

    const { currentInterval, deliveryIntervals } = useChunkIntervals(chunkId);

    const isNotInterval = deliveryIntervals.length === 0 || currentInterval.type === 'notInterval';

    const isLoading =
        isDeliveryAddressFilled &&
        (context.deliveryOptions.isLoading || isOrderSideUpdating || (isNotInterval && isOrderUpdating));

    const isInvalidOzonUser = useIsInvalidOzonUser({ chunkId, type: 'delivery' });
    const ozonDeliveryInterval = useOzonDeliveryInterval({ openRegistrationOzon });
    const { caption } = useOzonTriggerProps({ isShow: isInvalidOzonUser, openRegistrationOzon });

    if (isNotInterval && !isLoading) {
        return null;
    }

    return (
        <>
            {isPickupPointDeliveryMethod && (
                <FormField size="s">
                    {(fieldProps) => (
                        <DeliveryIntervalInput
                            {...fieldProps}
                            placeholder="Дата доставки"
                            onChange={(value) => {
                                fields.deliveryPickupPointInterval.actions.setValueByChunkId(chunkId, value);
                            }}
                            isLoading={isLoading}
                            isDisabled={deliveryIntervals.length === 1}
                            intervals={deliveryIntervals}
                            size="m"
                            value={currentInterval}
                            isShowServiceLogo={isCourierDeliveryMethod}
                            deliveryMethod={fieldDeliveryMethod.value}
                            ozonDeliveryInterval={ozonDeliveryInterval}
                        />
                    )}
                </FormField>
            )}
            {isCourierDeliveryMethod && (
                <FormField size="s">
                    {(fieldProps) => (
                        <DeliveryIntervalInput
                            {...fieldProps}
                            placeholder="Дата и время доставки"
                            onChange={(value) => {
                                fields.deliveryCourierInterval.actions.setValueByChunkId(chunkId, value);
                            }}
                            isLoading={isLoading}
                            isDisabled={deliveryIntervals.length === 1}
                            intervals={deliveryIntervals}
                            size="m"
                            caption={caption}
                            value={currentInterval}
                            isShowServiceLogo={isCourierDeliveryMethod}
                            deliveryMethod={fieldDeliveryMethod.value}
                            ozonDeliveryInterval={ozonDeliveryInterval}
                        />
                    )}
                </FormField>
            )}
        </>
    );
};
